import React from 'react'
import {Snackbar, IconButton, CircularProgress, Typography, makeStyles} from "@material-ui/core/";
import CloseIcon from "@material-ui/icons/Close";
import PlayIcon from '@material-ui/icons/PlayArrow';
import ReplayIcon from '@material-ui/icons/Replay';
import PauseIcon from '@material-ui/icons/Pause';
import SettingsIcon from '@material-ui/icons/Settings';
import { useTextToSpeech } from './useTextToSpeech';
import { UserAgent } from '../../../../utilities/UserAgent';

const useStyles = makeStyles(() => ({
        root: {
            position: 'absolute',
          },
          backdrop: {
            position: 'absolute',
          },
        mobileMessageWraper: {
            overflow: 'hidden', 
            position: "absolute", 
            top: 20, 
            left: 5,
        },
        desktopMessageWraper: {
            overflow: 'hidden', 
            position: "absolute", 
            top: 20, 
            left: 5,
            width: 80,
            marginRight: 20
        },
        message: {
            color: 'white',
            whiteSpace: 'nowrap',
            animation: 'slide 5s linear infinite'
        },
        '@keyframes slide': {
            "0%": {
                transform: 'translatex(100%)'
            },
            '100%': {
                transform: 'translatex(-150%)'
            }
        }
}));

export function TextToSpeechPlayer(){
    const classes = useStyles();
    const textToSpeech = useTextToSpeech();
    const { isAudioPaused, showAudioPlayer, pauseTextToSpeech, resumeTextToSpeech, stopTextToSpeech, restartTextToSpeech, isLoading, toggleSettingsOpen } = textToSpeech;
    const isMobile = UserAgent.mobile()
        
    return (
        <Snackbar
        anchorOrigin={{
         vertical: "top",
         horizontal: "center"   
        }}
        
        className={classes.root}
        classes={{
          root: classes.root,
        }}
        style={{ position: 'absolute', top: isMobile ? 70 : 40, zIndex: 1199}}
        open={showAudioPlayer}
        message={ !isLoading
                    ? 
                    <span key="0" className={isMobile ? classes.mobileMessageWraper : classes.desktopMessageWraper}>
                        <Typography className={classes.message}>Listening to sermon</Typography>
                    </span>
                    : <CircularProgress size={25}/>
                }
        action={<span key="1" >
                    { isAudioPaused
                        ? 
                        <IconButton
                        key="resume"
                        aria-label="resume"
                        color="inherit"
                        onClick={resumeTextToSpeech}
                        disabled={isLoading}
                        >
                        <PlayIcon />
                        </IconButton>
                        :
                        <IconButton
                        key="pause"
                        aria-label="pause"
                        color="inherit"
                        onClick={pauseTextToSpeech}
                        disabled={isLoading}
                        >
                        <PauseIcon />
                    </IconButton>
                }
                <IconButton
                key="restart"
                aria-label="restart"
                color="inherit"
                onClick={restartTextToSpeech}
                disabled={isLoading}
                >
                    <ReplayIcon />
                </IconButton>
                <IconButton
                key="settings"
                aria-label="settings"
                color="inherit"
                onClick={toggleSettingsOpen}
                >
                    <SettingsIcon />
                </IconButton>
                <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                onClick={stopTextToSpeech}
                >
                    <CloseIcon />
                </IconButton>
            </span>
        }/>
    )
}